module.exports = __webpack_public_path__ + "static/media/icon-confirm.ec7f041d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/Alerts/icon-confirm.svg
// module id = 1415
// module chunks = 2